const NAMESPACE = "submitProject";

const KEYS = {
    thankYouMessage: "thankYouMessage",
    projectNumberHeader: "projectNumberHeader"
};

const MESSAGES = {
    [KEYS.thankYouMessage]: {
        value: "Thank you for your submission.",
        comment: "Message shows on modal after project submission"
    },
    [KEYS.projectNumberHeader]: {
        value: "Your project number is:",
        comment: "Comes before the project number of a newly created project"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
